<template>
  <ChecklistTableTaskCellWrapper :clickable="isButtonDisplayed"
                                 data-locator="attachments-aera"
                                 @click="onOpenChecklistPane"
  >
    <template v-if="isButtonDisplayed">
      <v-chip class="ChecklistTableTaskAttachedFilesDialog-button clickable"
              data-locator="attachments-button"
              variant="outlined"
              color="grey"
              size="small"
      >
        {{ $t('project.checklist.dialogs.ChecklistTableTaskAttachedFilesDialog.buttonText', { attachmentCount: filesCount }, filesCount) }}
      </v-chip>
    </template>
    <template v-else>
      <ChecklistTableTaskEmptyCell />
    </template>
  </ChecklistTableTaskCellWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'


import ChecklistTableTaskCellWrapper from '@/project/checklist/table/ChecklistTableTaskCellWrapper.vue'
import ChecklistTableTaskEmptyCell from '@/project/checklist/table/ChecklistTableTaskEmptyCell.vue'
import { OPEN_CHECKLIST_PANE } from '@/store/modules/checklist/action_types'


export default {
  name: 'ChecklistTableTaskDocument',
  components: {
    ChecklistTableTaskEmptyCell,
    ChecklistTableTaskCellWrapper,
  },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['currentUserRights', 'isCurrentUserPm']),
    filesCount () {
      return this.item?.files ? Object.keys(this.item.files).length : 0
    },
    isButtonDisplayed () {
      if (this.isCurrentUserPm || this.currentUserRights.canUpload) {
        return true
      }
      return this.filesCount > 0
    },
  },
  methods: {
    ...mapActions('checklist', [OPEN_CHECKLIST_PANE]),
    onOpenChecklistPane() {
      if (!this.isButtonDisplayed) return
      
      this.OPEN_CHECKLIST_PANE({
        isOpen: true,
        parent: this.parent,
        tab: 'files',
        tasks: [this.item],
      })
    },
  },
}
</script>

<style scoped>
.ChecklistTableTaskAttachedFilesDialog-button {
  height: 24px;
}
</style>
